module.exports = __webpack_public_path__ + "static/media/theme_påske.d0677961.jpg";